import './Nelson.css'

const noop = () => {}

const Nelson = ({
  onScreenUpdate = noop,
  showDialogue,
  setShowDialogue,
  learnLink,
  dialogue = null,
  dialogueLinkText = 'Learn More',
}) => {
  const cName = 'nelson '

  const doClose = () => {
    setShowDialogue(false)
  }

  const onComingSoonClick = () => {
    onScreenUpdate('soon')
  }

  return (
    <div className="nelsonArea">
      <div className={cName}>
        <img src="images/Nelson.png" alt="Front view of Lord Nelson, a horse" />
        {showDialogue ? (
          <div className="nelsonBubble">
            <div>{dialogue}</div>
            <div>
              {learnLink === 'soon' ? (
                <button
                  href=""
                  className="comingSoonButton"
                  onClick={onComingSoonClick}
                >
                  {dialogueLinkText}
                </button>
              ) : (
                <a href={learnLink} target="_blank" rel="noreferrer">
                  {dialogueLinkText}
                </a>
              )}
            </div>
            <button className="closeButton" onClick={() => doClose()}>
              X
            </button>
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default Nelson
